import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, BoxExtendedProps } from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  onSetVisible: (value: boolean) => void;
}

const SavedReceiptsFooter: React.FC<Props> = ({ onSetVisible, ...props }) => {
  const { t } = useTranslation();
  
  const handleClose = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  const handleSubmit = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  return (
    <Box direction="row" align="center" {...props}>
      <Box gap="spacing8" direction="row" margin={{ left: 'auto' }}>
        <AppButton
          width="160px"
          onClick={handleClose}
          buttonType="secondary"
        >
          {t('Close')}
        </AppButton>
        <AppButton
          width="160px"
          onClick={handleSubmit}
        >
          {t('Submit')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default SavedReceiptsFooter;
